// list
// API related actions
export const LOADING_LIQUIDATIONS_LIST = '@@toyota/LOADING_LIQUIDATIONS_LIST';
export const LOADED_LIQUIDATIONS_LIST = '@@toyota/LOADED_LIQUIDATIONS_LIST';
export const LOADED_LIQUIDATIONS_LIST_FAILED = '@@toyota/LOADED_LIQUIDATIONS_LIST_FAILED';
export const LOADING_LIQUIDATIONS_DETAIL = '@@toyota/LOADING_LIQUIDATIONS_DETAIL';
export const LOADED_LIQUIDATIONS_DETAIL = '@@toyota/LOADED_LIQUIDATIONS_DETAIL';
export const LOADED_LIQUIDATIONS_DETAIL_FAILED = '@@toyota/LOADED_LIQUIDATIONS_DETAIL_FAILED';

// complementary actions
export const EMPTY_LIQUIDATIONS_LIST = '@@toyota/EMPTY_LIQUIDATIONS_LIST';


// KPI by days
// API related actions
export const LOADING_LIQUIDATIONS_BY_DAYS = '@@toyota/LOADING_LIQUIDATIONS_BY_DAYS';
export const LOADED_LIQUIDATIONS_BY_DAYS = '@@toyota/LOADED_LIQUIDATIONS_BY_DAYS';
export const LOADED_LIQUIDATIONS_BY_DAYS_FAILED = '@@toyota/LOADED_LIQUIDATIONS_BY_DAYS_FAILED';
export const LOADING_LIQUIDATIONS_BY_DAY_DETAIL = '@@toyota/LOADING_LIQUIDATIONS_BY_DAY_DETAIL';
export const LOADED_LIQUIDATIONS_BY_DAY_DETAIL = '@@toyota/LOADED_LIQUIDATIONS_BY_DAY_DETAIL';
export const LOADED_LIQUIDATIONS_BY_DAY_DETAIL_FAILED = '@@toyota/LOADED_LIQUIDATIONS_BY_DAY_DETAIL_FAILED';
